exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._15JSx{margin-bottom:5px;display:block;color:red;font-size:14px;font-weight:400}._3vxLV{margin-bottom:16px}._2LQUa{padding:10px 35px 10px 10px;height:64px;border-radius:2px;font-size:16px}.aIJ6M{overflow:hidden}._1iCVB{padding:0}._3O5sK{text-align:right}.YAX54{text-align:left}._2jcVt{text-align:center}._1TPd8{color:#008489}.vUDI_{font-size:16px;line-height:32px}._1TPd8:focus,._1TPd8:hover{color:#008489;text-decoration:underline;cursor:pointer}._138K6{display:block;box-sizing:border-box;margin:0;padding:20px 16px;width:100%;outline:0;border:1px solid #373277;border-radius:4px;background:#373277;color:#fff;text-align:center;text-decoration:none;font-size:16px;line-height:1.3333333;cursor:pointer}._138K6:hover{background:rgba(54,50,119,.8)}._138K6:focus{border-color:#0074c2;box-shadow:0 0 8px rgba(0,116,194,.6)}._1tVae{border-color:#ff5a5f;background-color:#ff5a5f;color:#fff}._1tVae:focus,._1tVae:hover{border-color:#ff7e82!important;background-color:#ff7e82!important;color:#fff}._3NBnc{border-color:#ff5a5f;color:#ff5a5f;background-color:#fff}._3NBnc:focus,._3NBnc:hover{border-color:#ff7e82;color:#ff7e82;background-color:#fff}.IvsfJ{padding:5px 0}._9J9ui{position:relative;z-index:1;display:block;margin:15px 0;width:100%;color:#767676;text-align:center;font-size:14px}", ""]);

// exports
exports.locals = {
	"errorMessage": "_15JSx",
	"formGroup": "_3vxLV",
	"formControlInput": "_2LQUa",
	"formSection": "aIJ6M",
	"noPadding": "_1iCVB",
	"textAlignRight": "_3O5sK",
	"textAlignLeft": "YAX54",
	"textAlignCenter": "_2jcVt",
	"modalCaptionLink": "_1TPd8",
	"modalCaptionLinkLarge": "vUDI_",
	"button": "_138K6",
	"btnPrimary": "_1tVae",
	"btnPrimaryBorder": "_3NBnc",
	"btnSmall": "IvsfJ",
	"horizontalLineThrough": "_9J9ui"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/LoginForm/Login.css
// module id = 2545
// module chunks = 15